import { requireFeatureFlag, FeatureFlagsUnavailableError } from "src/api/featureFlags";

import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse, serviceUnavailableResponse, successResponse } from "../constants";

export const loader = async (user: User) => {
  /**
   * Loader function for IPL pages
   *
   * @returns {Promise<Response>} A Promise that resolves with a Response object.
   *   Returns OK if user has IPL role and IPL claims feature is enabled
   *   Returns 403 Forbidden if the user lacks the role or the feature is disabled
   *   Returns 503 Service Unavailable if the feature flag lookup failed, so an
   *     outage is not reported to the user as a permissions problem
   */
  let isIplEnabled: boolean;
  try {
    isIplEnabled = await requireFeatureFlag("enableIplClaims");
  } catch (error) {
    if (error instanceof FeatureFlagsUnavailableError) {
      throw serviceUnavailableResponse(
        "We could not confirm whether IPL claim intake is available right now. " +
          "Please retry in a few moments."
      );
    }
    throw error;
  }

  if (isIplEnabled && user.roles.includes(Role.IPL_CLAIM_USER)) {
    return successResponse();
  } else {
    throw forbiddenResponse();
  }
};
